"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Call_exports = {};
__export(Call_exports, {
  default: () => Call_default
});
module.exports = __toCommonJS(Call_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.6328 13.6484C16.6328 13.4661 16.5742 13.3099 16.457 13.1797C16.3529 13.0365 16.2161 12.9518 16.0469 12.9258C15.6953 12.8867 15.3438 12.8216 14.9922 12.7305C14.6406 12.6393 14.3021 12.5352 13.9766 12.418C13.8464 12.3659 13.7161 12.3529 13.5859 12.3789C13.4557 12.4049 13.3451 12.4701 13.2539 12.5742L12.375 13.4336C12.2708 13.5378 12.1406 13.6029 11.9844 13.6289C11.8281 13.6549 11.6849 13.6289 11.5547 13.5508C11.099 13.2904 10.6628 13.0039 10.2461 12.6914C9.82943 12.3659 9.4388 12.0208 9.07422 11.6562C8.70964 11.2917 8.37109 10.901 8.05859 10.4844C7.73307 10.0677 7.4401 9.63151 7.17969 9.17578C7.10156 9.04557 7.07552 8.90885 7.10156 8.76562C7.1276 8.60938 7.19271 8.47266 7.29688 8.35547L8.15625 7.49609C8.26042 7.40495 8.32552 7.29427 8.35156 7.16406C8.3776 7.03385 8.36458 6.90365 8.3125 6.77344C8.19531 6.4349 8.09115 6.09635 8 5.75781C7.90885 5.40625 7.84375 5.05469 7.80469 4.70312C7.77865 4.53385 7.70052 4.39714 7.57031 4.29297C7.4401 4.17578 7.28385 4.11719 7.10156 4.11719H5.05078C4.95964 4.11719 4.86849 4.13672 4.77734 4.17578C4.6862 4.21484 4.60807 4.26693 4.54297 4.33203C4.47786 4.41016 4.43229 4.49479 4.40625 4.58594C4.38021 4.67708 4.36719 4.76823 4.36719 4.85938C4.47135 5.86198 4.69271 6.83854 5.03125 7.78906C5.36979 8.73958 5.81901 9.63802 6.37891 10.4844C6.8737 11.2656 7.44661 11.9883 8.09766 12.6523C8.76172 13.3034 9.49089 13.8828 10.2852 14.3906C11.1315 14.9375 12.0234 15.3802 12.9609 15.7188C13.9115 16.0573 14.888 16.2786 15.8906 16.3828C15.9818 16.3958 16.0729 16.3893 16.1641 16.3633C16.2552 16.3242 16.3333 16.2721 16.3984 16.207C16.4766 16.1419 16.5352 16.0638 16.5742 15.9727C16.6133 15.8815 16.6328 15.7904 16.6328 15.6992V13.6484ZM18 15.6992C18 15.9857 17.9414 16.2591 17.8242 16.5195C17.707 16.7799 17.5443 17.0078 17.3359 17.2031C17.1146 17.3984 16.8672 17.5482 16.5938 17.6523C16.3203 17.7435 16.0404 17.776 15.7539 17.75C15.194 17.6849 14.6471 17.5872 14.1133 17.457C13.5664 17.3398 13.0326 17.1901 12.5117 17.0078C11.9909 16.8255 11.4831 16.6107 10.9883 16.3633C10.4935 16.1159 10.0117 15.8424 9.54297 15.543C8.67057 14.9831 7.86979 14.3451 7.14062 13.6289C6.41146 12.8997 5.77344 12.099 5.22656 11.2266C4.91406 10.7578 4.63411 10.276 4.38672 9.78125C4.13932 9.27344 3.92448 8.75911 3.74219 8.23828C3.5599 7.71745 3.40365 7.18359 3.27344 6.63672C3.15625 6.08984 3.0651 5.54297 3 4.99609C2.97396 4.70964 3.00651 4.42969 3.09766 4.15625C3.20182 3.88281 3.35156 3.63542 3.54688 3.41406C3.72917 3.20573 3.95052 3.04297 4.21094 2.92578C4.48438 2.80859 4.76432 2.75 5.05078 2.75H7.10156C7.6224 2.75 8.07812 2.91927 8.46875 3.25781C8.85938 3.58333 9.08724 4.00651 9.15234 4.52734C9.19141 4.82682 9.25 5.1263 9.32812 5.42578C9.40625 5.71224 9.4974 5.9987 9.60156 6.28516C9.74479 6.66276 9.77083 7.04688 9.67969 7.4375C9.60156 7.82812 9.41927 8.16667 9.13281 8.45312L8.64453 8.94141C9.04818 9.57943 9.51042 10.1654 10.0312 10.6992C10.5651 11.2201 11.151 11.6823 11.7891 12.0859L12.2773 11.5977C12.5638 11.3112 12.9023 11.1289 13.293 11.0508C13.6836 10.9596 14.0677 10.9857 14.4453 11.1289C14.7318 11.2331 15.0247 11.3242 15.3242 11.4023C15.6237 11.4805 15.9232 11.5391 16.2227 11.5781C16.7435 11.6432 17.1732 11.8776 17.5117 12.2812C17.8503 12.6719 18.013 13.1276 18 13.6484V15.6992Z",
      fill: "currentColor"
    }
  )
);
const SvgCall = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Call_default = SvgCall;
